module.exports = __webpack_public_path__ + "static/media/sun-cloud.e85164a3.svg";